/**
 * Whether the home create panel offers Request files (kitecorp/transferify-ui#3140).
 *
 * To everyone on the landing, signed out included (owner 2026-10-01: "request files should be visible to
 * the signed out users as well. we can hook them into the site that way by asking for their email"): a
 * visitor who is not signed in gives their email and confirms it with a code, as a sender does, and that
 * makes their account. Not to a signed-in account awaiting activation, which cannot open Transfers
 * (`nav/appDestinations`), where a created request is listed. Never in the reply composer a download page
 * hosts, which answers one sender and hides the panel's other choices too.
 */
export function offersRequestFiles(session: {signedIn: boolean; accountActive: boolean; replying: boolean}): boolean {
	return !session.replying && (!session.signedIn || session.accountActive);
}
